import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const detailSlider = document.querySelector('.detail-slider__list');
if (detailSlider !== null) {
    new Swiper(detailSlider, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        navigation: {
            nextEl: '.detail-slider__navigation--next',
            prevEl: '.detail-slider__navigation--prev'
        },
        pagination: {
            el: '.detail-slider__pagination',
            bulletClass: 'detail-slider__pagination-bullet',
            bulletActiveClass: 'detail-slider__pagination-bullet--active',
            clickable: true
        }
    })
}